export default {
    JWT_TOKEN: 'accessToken'
}


// WEBPACK FOOTER //
// ./src/common/constants/keys.js